export enum Role {
  REGISTERED = 'registered',
  UNREGISTERED = 'unregistered',
  DEREGISTERED = 'deregistered'
}
